import esContent from './productDetails.es';

export default {
  ...esContent,
};
